import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=2ea37096&scoped=true"
import script from "./CustomFields.vue?vue&type=script&lang=js"
export * from "./CustomFields.vue?vue&type=script&lang=js"
import style0 from "./CustomFields.vue?vue&type=style&index=0&id=2ea37096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea37096",
  null
  
)

export default component.exports